import React, { useEffect } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

// Shutdown mode: Registration is disabled, redirect to login
function Register() {
  const router = useRouter()

  useEffect(() => {
    // Registration is disabled during shutdown - redirect to login
    router.replace('/auth/login')
  }, [router])

  return (
    <>
      <Head>
        <title>Platform Shutdown | Relysia</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=0.9 ,maximum-scale=1.0,
    user-scalable=0"
        />
      </Head>
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        color: '#fff',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <div>
          <h1 style={{ color: '#f59e0b', marginBottom: '1rem' }}>Registration Disabled</h1>
          <p style={{ marginBottom: '1rem' }}>The Relysia platform has been shut down. New registrations are not available.</p>
          <p>Redirecting to login page...</p>
        </div>
      </div>
    </>
  )
}

export default Register
